import React from 'react'
import { HeaderWithBetaStyles } from './Style'

const BetaHeaderCell = ({ children }) => {

    return (
        <HeaderWithBetaStyles>
            <div>{children}</div>
            <div className='beta-chip'>
                {"Beta"}
            </div>
        </HeaderWithBetaStyles>
    )
}
export default BetaHeaderCell